import React from 'react';
import { NavLink } from 'react-router-dom';
import '../assets/styles/global.css';

const ButtonComponent = ({ text, onClick, className, to,type, ...props }) => {
  return to ? (
    <NavLink 
      to={to} 
      className={({ isActive }) => isActive ? `${className} secondary-bg` : className}
    >
      {({ isActive }) => (
        <button
          className={`button-md ${className} ${isActive ? 'secondary-bg' : 'primary-bg'}`} 
          onClick={onClick} 
          {...props}
        >
          {text}
        </button>
      )}
    </NavLink>
  ) : (
    <button type={type}  className={`button-md ${className} `} onClick={onClick} {...props}>
      {text}
    </button>
  );
};

export default ButtonComponent;
